export default "__VITE_ASSET__CzJxJP3b__"